import { notificationPeriodicType } from "../constants"


// Returns the default notification periodic set in the constants
export const getDefaultNotificationPerodic = () => {
   return notificationPeriodicType.filter(({isDefault}) => isDefault)[0].type
} 

export const getSearchParams = (searchParams: any) => {
   let searchFilters: { [key: string]: string[] } = {}
   for (const entry of searchParams.entries()) {
      let [param, value] = entry
      // cx_topics, communication_mode, keywords values should be sent as an array
      value = (param == 'cx_topics' || param == 'communication_mode' || param == 'keywords') ? value.split(',') : value 
      searchFilters[param] = value
   }
   return searchFilters
}